import service from '@/services/superaccess'

const novelty = {
  state: {
    novelty_types_modal: false,
    novelties_modal: false
  },
  mutations: {
    updateStatusNoveltyTypeModal (state, status) {
      state.novelty_types_modal = status
    },
    updateStatusNoveltyModal (state, status) {
      state.novelties_modal = status
    }
  },
  getters: {
    getStatusNoveltyTypeModal (context) {
      return context.novelty_types_modal
    },
    getStatusNoveltyModal (context) {
      return context.novelties_modal
    }
  },
  actions: {
    setStatusNoveltyTypeModal (context, payload) {
      context.commit('updateStatusNoveltyTypeModal', payload)
    },
    setStatusNoveltyModal (context, payload) {
      context.commit('updateStatusNoveltyModal', payload)
    },
    saveNoveltyType (context, payload) {
      return service.post('/api/novelty_types/create', context, { novelty_type: payload })
    },
    modifyNoveltyType (context, payload) {
      return service.patch('/api/novelty_types/modify', context, { novelty_type: payload })
    },
    changeNoveltyTypeState (context, payload) {
      return service.patch('/api/novelty_types/change', context, payload)
    },
    saveTemporaryNovelty (context, payload) {
      return service.post('/api/novelty/create', context, { novelty: payload })
    },
    modifyTemporaryNovelty (context, payload) {
      return service.patch('/api/novelty/modify', context, { novelty: payload })
    },
    changeTemporaryNoveltyState (context, payload) {
      return service.patch('/api/novelty/change', context, payload)
    },
    retrieveNoveltyTypes (context, payload) {
      return service.get('/api/novelty/new', context)
    }
  }
}

export default novelty



// WEBPACK FOOTER //
// app/javascript/src/store/novelty.js